<!--
  @Description: 信息流-收藏
  @Author: wang.y 
  @Date: 2022-02-23 
-->
<template>
  <div>
    <div class="commonlist">
      <div v-for="(item, index) in list" :key="index">
        <!-- 快讯 -->
        <div class="item" v-if="item.content_type == 0">
          <div class="title over-p1" @click="$parent.goDetail(item.content_type, item.content_uid)"><span>快讯</span>{{item.title}}</div>
          <div class="dec">
            <div class="lt">
              <div class="info-item"><i class="iconfont">&#xe632;</i>发文时间：{{item.publish_time | time_standard}}</div>
            </div>
            <div class="collect_share">
              {{item.create_time}}
              <i class="iconfont collec-icon" @click="handleCancel('0', item.content_id, cancelCollectCb, index)" title="取消收藏">&#xe66f;</i>
            </div>
          </div>
        </div>
        <!-- 政策 -->
        <div class="item" v-if="item.content_type == 3">
          <div class="title over-p2" @click="$parent.goDetail(item.content_type, item.content_uid)"><span>政策</span>{{item.title}}</div>
          <div class="dec">
            <div class="lt">
              <div class="info-item"><i class="iconfont">&#xe632;</i>发文时间：{{item.publish_time | time_standard}}</div>
              <div class="info-item" v-if="item.address_id && item.address_id != '0'"><i class="iconfont">&#xe62c;</i>有效地区：{{item.address_id | addressDeal('3', $store.state.address)}}</div>
              <div class="info-item" v-if="item.src_author"><i class="iconfont">&#xe633;</i>发文机关：{{item.src_author}}</div>
            </div>
            <div class="collect_share">
              {{item.create_time}}
              <i class="iconfont collec-icon" @click="handleCancel('3', item.content_id, cancelCollectCb, index)" title="取消收藏">&#xe66f;</i>
            </div>
          </div>
        </div>
        <!-- 报告 -->
        <div class="img-item" v-if="item.content_type == 1">
          <div class="img" @click="$parent.goDetail(item.content_type, item.content_uid)">
            <img :src="item.logo_path | logo_show" class="logo" />
            <img :src="$store.state.static_img_url + 'pic/list/u-li-type-2.png'" class="u-li-type">
          </div>
          <div class="info">
            <div class="title over-p2" @click="$parent.goDetail(item.content_type, item.content_uid)">{{item.title}}</div>
            <div class="summary over-p2">{{item.summary}}</div>
            <div class="dec">
              <div class="lt">
                <!-- {{item.src_author}} -->
                <div class="info-item"><i class="iconfont">&#xe645;</i>{{item.src_author}}</div>
              </div>
              <div class="collect_share">
                {{item.create_time}}
                <i class="iconfont collec-icon" @click="handleCancel('1', item.content_id, cancelCollectCb, index)" title="取消收藏">&#xe66f;</i>
              </div>
            </div>
          </div>
        </div>
        <!-- 专题Pro -->
        <div class="img-item" v-if="item.content_type == 2">
          <div class="img" @click="$parent.goDetail(item.content_type, item.content_uid)">
            <img :src="item.logo_path | logo_show" class="logo" />
            <img :src="$store.state.static_img_url + 'pic/list/u-li-type-1.png'" class="u-li-type">
          </div>
          <div class="info">
            <div class="title over-p2" @click="$parent.goDetail(item.content_type, item.content_uid)">{{item.title}}</div>
            <div class="summary over-p2">{{item.summary}}</div>
            <div class="dec">
              <!-- <div class="lt">
                <div class="last-updata">2022-02-08更新：数字药房Alto宣布完成2亿美元E轮融资，由Softbank Vision Fund领投</div>
              </div> -->
              <div class="collect_share">
                {{item.create_time}}
                <i class="iconfont collec-icon" @click="handleCancel('2', item.content_id, cancelCollectCb, index)" title="取消收藏">&#xe66f;</i>
              </div>
            </div>
          </div>
        </div>
        <!-- 文章 -->
        <div class="img-item" v-if="item.content_type == 4">
          <div class="img" @click="$parent.goDetail(item.content_type, item.content_id)">
            <img :src="item.logo_path | logo_show" class="logo" />
          </div>
          <div class="info">
            <div class="title over-p2" @click="$parent.goDetail(item.content_type, item.content_id)">{{item.title}}</div>
            <div class="summary over-p2">{{item.summary}}</div>
            <div class="dec">
              <div class="lt">
                <img :src="item.src_author_logo_path | logo_show" class="header-img" />
                <span class="span1">{{item.author_name}}</span>
                <span class="span1">{{item.publish_time}}</span>
              </div>
              <div class="collect_share">
                {{item.create_time}}
                <i class="iconfont collec-icon" @click="handleCancel('4', item.content_id, cancelCollectCb, index)" title="取消收藏">&#xe66f;</i>
              </div>
            </div>
          </div>
        </div>
        <!-- 数据图片 -->
        <div class="img-item" v-if="item.content_type == 9">
          <div class="img2" @click="handReport(item)">
            <img :src="item.logo_path | logo_show('/report_image')" class="pic" />
          </div>
          <div class="info">
            <div class="title over-p2" @click="handReport(item)">{{item.title}}</div>
            <div class="source">
              <div>所属报告：</div>
              <!-- <div class="report" @click="$parent.goDetail(1, item.content_uid)">{{item.src_author}}</div> -->
              <div class="report">{{item.src_author}}</div>
            </div>
            <div class="dec">
              <div class="lt"></div>
              <div class="collect_share">
                {{item.create_time}}
                <i class="iconfont collec-icon" @click="handleCancel('9', item.content_id, cancelCollectCb, index)" title="取消收藏">&#xe66f;</i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Spin v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="more-btn" v-if="more && !loading">
      <div @click="handleMore">加载更多</div>
    </div>
    <default-list v-if="!list.length && !loading">
      <template slot="p">
        <p>您目前没有收藏任何信息，不如去随便逛逛<br />看看有什么内容值得收藏起来，反复品读</p>
      </template>
    </default-list>
    <ReportModal :isReportModal="is_reportModal" :detail="detail" :relation="relation" @closeModal="closeModal"></ReportModal>
  </div>
</template>
<script>
import DefaultList from './DefaultList'
import { getXuserFavoriteAll, getReportChartList } from '@/service'
import ReportModal from '@/components/vcbeat/ReportModal'
export default {
  components: { DefaultList, ReportModal },
  created() {
    this.getXuserFavoriteAll()
  },
  mounted() { },
  data() {
    return {
      is_reportModal: false,
      detail: {},
      relation: [],
      loading: false,
      list: [],
      more: true,
      page: 1
    }
  },
  computed: {},
  methods: {
    //图表弹窗
    async handReport(item) {
      this.detail = {
        filePath: item.logo_path,
        fileName: item.title,
        reportTitle: item.src_author,
        id: item.content_id - 0,
        reportUid: item.content_uid,
      }
      let res = await getReportChartList( {
        file_id: item.id - 0,
        app_layer_tag: [],
        name: '',
        page: 1,
        size: 3
      }, (error) => {
        this.$message.error('请求错误！')
      })
      if (res.code == 0) {
        this.$set(this.$data, 'relation', res.data.records)
        this.is_reportModal = true
      } else {
        this.$message.error(res.msg)
      }
    },
    async getXuserFavoriteAll() {
      this.loading = true
      let res = await getXuserFavoriteAll({
        user_key: this.$store.state.user_key,
        page: this.page
      }, (error) => {
        this.$Message.error('请求错误')
      })
      if (res.status == 'success') {
        this.$parent.loading = false
        this.loading = false
        this.list = [...this.list, ...res.res]
        if (res.res.length < 10) {
          this.more = false
        }
      } else {
        this.$Message.error(res.message)
      }
    },
    handleCancel(content_type, content_id, collectCb, cb_param) {
      this.$parent.message_model = true
      this.$parent.content_type = content_type
      this.$parent.content_id = content_id
      this.$parent.collectCb = collectCb
      this.$parent.cb_param = cb_param
    },
    cancelCollectCb(index) {
      this.list.splice(index, 1)
    },
    handleMore(t) {
      this.page ++
      this.getXuserFavoriteAll()
    },
    closeModal() {
      this.is_reportModal = false
    }
  }
}
</script>
<style lang="stylus" scoped>
.commonlist
  > div + div
    margin-top 30px
</style>